<template>
  <Modal
    :id="'cmp-add-genre'"
    @cancelled="onCancelClick"
    :loadingFlag="loadingFlag"
  >
    <template slot="header">Add Genre</template>
    <template slot="body">
      <SearchList
        :id="'unrelated_genres'"
        ref="searchList"
        :items="unrelated_genres"
        :keyProperty="'genre_id'"
        :label="'genre_name'"
        @selected="onGenreSelected"
        @searched="onGenreSearched"
        @cancelNewItem="onCancelNewItem"
        @newAdded="onNewAddedGenre"
      />

      <!-- <table class="dt-table2 search-list">
        <tbody class="dt-table2--body">
          <tr
            class="dt-table2--row"
            v-for="unrelated_genre of unrelated_genres"
            :key="unrelated_genre['value']"
            @click="e => onClickRow(e, unrelated_genre)"
          >
            <td class="dt-table2--column">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  :name="unrelated_genre.genre_id"
                  :id="unrelated_genre.genre_id"
                  :checked="selected_genres.has(unrelated_genre.genre_id)"
                  @click="e => onGenreSelected(e, unrelated_genre.genre_id)"
                />
                <div class="checkmark"></div>
              </div>
            </td>
            <td class="dt-table2--column">{{unrelated_genre.genre_name}}</td>
          </tr>
        </tbody>
      </table>-->
    </template>
    <template slot="options">
      <!-- <button
        class="dt-button s6"
        
      >Add new Genre</button> -->
      <button class="dt-button with-ico s6" @click="createNewGenre">
        <div class="dt-icon-container">
          <img src="static/icons/plus.svg" class="dt-icon v7" alt />
        </div>
        <div class="button-text">
          {{ $t("add_new_genre") }}
        </div>
      </button>
      <button class="dt-button s6" @click="onCancelClick">Cancel</button>
      <button class="dt-button v1 s6" @click="onOKClick">OK</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "../modal/modal";
import SearchList from "../search-list/search-list";

import {
  allValidString,
  validString,
  setRandColor,
  addRemoveSet,
  waitForAnimation,
} from "../../utility";
import { NotificationService } from "../notification/notification.service";
import { GenreService } from "./genre.service";
import { getGenreConfig } from "./config";
import { configValidator } from "../modal/validator";

export default {
  components: {
    Modal,
    SearchList,
  },
  props: {},
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
      },
      unrelated_genres: [],
      selected_genres: new Set(),
      config: null,
      loadingFlag: false,
      genre_name: "",
    };
  },
  mixins: [configValidator({})],
  mounted: function () {
    this.fetchGenreList();
    this.config = getGenreConfig(this.external_table);
  },
  computed: {
    reqObject: function () {
      return {
        booking_location_id: this.booking_location_id,
        external_table: this.external_table,
      };
    },
    booking_location_id: function () {
      return this.$route.query.id;
    },
    external_table: function () {
      return this.$route.query.external_table;
    },
  },
  methods: {
    // onGenreSelected: async function(event, genre_id) {
    //   this.selected_genres = addRemoveSet(
    //     event.target.checked,
    //     this.selected_genres,
    //     genre_id
    //   );
    //   const addGenre = await GenreService.addGenre({
    //     external_id: this.booking_location_id,
    //     genre_id: genre_id,
    //     external_table: this.external_table
    //   });
    // },
    fetchGenreList: function () {
      GenreService.findGenres({
        booking_location_id: this.booking_location_id,
      }).then((res) => {
        this.unrelated_genres = res.data.unrelated_genres;
      });
    },
    onGenreSelected: async function (selected) {
      this.selected_genres = selected;
    },
    onGenreSearched: async function (search) {
      const genres = await GenreService.searchGenre({
        search: search,
        booking_location_id: this.booking_location_id,
      });
      // console.log(genres.data);
      this.unrelated_genres = genres.data.unrelated_genres;
    },
    onCancelClick: function () {
      this.$emit("cancelled", true);
    },
    onOKClick: async function () {
      console.log("on OK CLI", Array.from(this.selected_genres));
      this.loadingFlag = true;
      const allAdd = await Promise.all(
        Array.from(this.selected_genres).map((genre_id) =>
          GenreService.addGenre({
            external_id: this.booking_location_id,
            genre_id: genre_id,
            external_table: this.external_table,
          })
        )
      );
      console.log(allAdd);

      this.loadingFlag = false;

      this.$emit("done", {
        action: this.config.action,
        booking_location_id: this.booking_location_id,
      });
    },
    insertNewGenre: async function () {
      const insertedGenres = await GenreService.insertGenre({
        genre_name: this.genre_name,
        external_id: this.external_id,
        external_table: this.external_table,
      });
    },
    createNewGenre: async function () {
      this.unrelated_genres = [
        ...this.unrelated_genres,
        {
          genre_id: "NEW_ITEM_TEMP",
        },
      ];
      waitForAnimation(() => {
        this.$refs["searchList"].focusNewInput();
      });
    },
    onCancelNewItem: function () {
      this.unrelated_genres = this.unrelated_genres.filter(
        (genre) => genre.genre_id !== "NEW_ITEM_TEMP"
      );
    },
    onNewAddedGenre: async function (genreName) {
      const insertedGenre = await GenreService.insertGenre({
        genre_name: genreName,
        external_id: this.booking_location_id,
        external_table: this.external_table,
      });

      console.log(insertedGenre.data);
      await this.fetchGenreList();
    },

    //MARK: methods
  },
};
</script>

<style lang="scss">
.cmp-add-genre {
  .item-search {
    width: 290px;
  }
  .dt-table2 {
    --body-height: 380px !important;
  }
}
</style>